import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/jenkins/deployment/obituary-app/staging-fe/obituary-app-fe/app/components/appcomponents/Layout.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/jenkins/deployment/obituary-app/staging-fe/obituary-app-fe/app/pogrebi/PogrebiListContent.tsx");
